document.addEventListener("DOMContentLoaded", () => {

    // If there is more than one .control-spaces-list, we need to setup the script to handle it separately
    const spacesListControls = document.querySelectorAll('.control-spaces-list');
    spacesListControls.forEach((spacesListControlDoc) => {

        // Get all the fields for filtering the spaces list
        const hotelInput = spacesListControlDoc.querySelector('#spaces-filter-hotel');
        const destinationInput = spacesListControlDoc.querySelector('#spaces-filter-destination');
        const eventTypeInput = spacesListControlDoc.querySelector('#spaces-filter-eventtype');
        const capacityInput = spacesListControlDoc.querySelector('#spaces-filter-capacity');
        const roomSetupInput = spacesListControlDoc.querySelector('#spaces-filter-room-setup');

        const setInputValue = (input, value) => {
            if (input) input.value = value;
        };

        // Show only hotels belonging to the selected destination. The empty option
        // remains available so the hotel filter can always be cleared.
        const updateHotelOptions = (clearInvalidSelection = true) => {
            if (!hotelInput) return;

            const selectedDestination = destinationInput?.value.trim() ?? '';
            const hotelOptions = hotelInput.querySelectorAll('option');
            let selectedHotelIsValid = !hotelInput.value;

            hotelOptions.forEach((hotelOption) => {
                const isAllHotelsOption = !hotelOption.value;
                const belongsToDestination = !selectedDestination
                    || isAllHotelsOption
                    || hotelOption.dataset.destination === selectedDestination;

                hotelOption.hidden = !belongsToDestination;

                if (hotelOption.value === hotelInput.value) {
                    selectedHotelIsValid = belongsToDestination;
                }
            });

            if (clearInvalidSelection && !selectedHotelIsValid) {
                setInputValue(hotelInput, '');
            }
        };

        const scrollToAnchor = () => {
            spacesListControlDoc.querySelectorAll('.space-card.show-card').forEach((spaceCard) => {
                spaceCard.classList.remove('show-card');
            });

            const spaceAnchor = window.location.hash.slice(1);
            if (!spaceAnchor) return;

            const spaceElement = spacesListControlDoc.querySelector(`.space-card.${CSS.escape(spaceAnchor)}`);
            if (!spaceElement) return;

            if (spaceElement.classList.contains('hidden-card')) {
                spaceElement.classList.add('show-card');
            }

            window.requestAnimationFrame(() => {
                const headerOffset = 100;
                const elementTop = spaceElement.getBoundingClientRect().top + window.scrollY;

                window.scrollTo({
                    top: elementTop - headerOffset,
                    behavior: 'smooth'
                });
            });
        };

        // Function that takes query string parameters for the filters and applies them to the spaces list, hiding any space cards that don't match the filters. The function also updates the filter inputs to reflect the applied filters.
        const applyFiltersFromQueryString = (queryString) => {
            const urlParams = new URLSearchParams(queryString);
            const destination = urlParams.get('destination') ?? '';
            const hotel = urlParams.get('hotels') ?? '';
            const eventType = urlParams.get('eventtype') ?? '';
            const capacity = urlParams.get('capacity') ?? '';
            const roomSetup = urlParams.get('room-setup') ?? '';

            setInputValue(destinationInput, destination);
            updateHotelOptions(false);
            setInputValue(hotelInput, hotel);
            updateHotelOptions();
            setInputValue(eventTypeInput, eventType);
            setInputValue(capacityInput, capacity);
            setInputValue(roomSetupInput, roomSetup);
            syncCapacityDirtyState(capacityInput);

            applyFilters(spacesListControlDoc);

            scrollToAnchor();
        };

        window.addEventListener('hashchange', scrollToAnchor);

        // Setup the filter button to toggle the filter row visibility
        spacesListControlDoc.querySelector('.filter-button')?.addEventListener('click', event => {
            event.preventDefault();
            spacesListControlDoc.querySelector('.filter-row')?.classList.toggle('active');
        });

        // Setup the filter close button to hide the filter row
        spacesListControlDoc.querySelector('.filter-close')?.addEventListener('click', event => {
            event.preventDefault();
            spacesListControlDoc.querySelector('.filter-row')?.classList.remove('active');
        });

        // Get the card layout from the dataset if present.
        const getCardLayouts = (spaceCard) => {
            try {
                return spaceCard.dataset.layouts ? JSON.parse(spaceCard.dataset.layouts) : [];
            } catch (error) {
                return [];
            }
        };

        // Get the default state of the filters.
        const getDefaultState = () => {
            return {
                capacity: '',
                layout: '',
                layoutText: 'Setup'
            };
        };

        // Function to toggle the dirty state of the capacity input field based on its value.
        const syncCapacityDirtyState = (input) => {
            input?.classList.toggle('dirty', input.value.trim().length > 0);
        };

        const syncEmptyState = (spacesListControl) => {
            const emptyState = spacesListControl?.querySelector('.space-list-empty');
            if (emptyState) emptyState.hidden = !!spacesListControl.querySelector('.space-card:not(.hidden-card), .space-card.show-card');
        };

        const applyFilters = (spacesListControl) => {
            if (!spacesListControl) return;

            // If the filter-row is active, close it after applying the filters
            spacesListControl.querySelector('.filter-row')?.classList.remove('active');

            const capVal = capacityInput?.value.trim();
            const selectedCapacitys = capVal ? Number(capVal) : null;

            const selectedRoomSetup = roomSetupInput?.value.trim() ?? '';

            spacesListControl.querySelectorAll('.space-card')?.forEach((spaceCard) => {
                const layouts = getCardLayouts(spaceCard);
                let isMatch = true;

                if (selectedRoomSetup || selectedCapacitys !== null) {
                    isMatch = layouts.some((layout) => {
                        const matchesRoomSetup = !selectedRoomSetup || layout.key === selectedRoomSetup;
                        const matchesCapacitys = selectedCapacitys === null
                            || (typeof layout.min === 'number'
                                && typeof layout.max === 'number'
                                && selectedCapacitys >= layout.min
                                && selectedCapacitys <= layout.max);

                        return matchesRoomSetup && matchesCapacitys;
                    });
                }

                // Apply hotel, destination, and event type filtering.
                const selectedHotel = hotelInput?.value.trim() ?? '';
                const selectedDestination = destinationInput?.value.trim() ?? '';
                const selectedEventType = eventTypeInput?.value.trim() ?? '';

                if (selectedHotel || selectedDestination || selectedEventType) {
                    isMatch = isMatch
                        && (!selectedHotel || spaceCard.dataset.hotel === selectedHotel)
                        && (!selectedDestination || spaceCard.dataset.destination === selectedDestination)
                        && (!selectedEventType || spaceCard.dataset.eventTypes.includes(selectedEventType));
                }

                spaceCard.classList.toggle('hidden-card', !isMatch);
            });

            syncEmptyState(spacesListControl);
        };

        // Function to reset all filters and show all space cards.
        const resetFilters = (spacesListControl) => {
            if (!spacesListControl) return;

            // Remove the value from hotels, destinations, capacity, room setup, and event type inputs
            setInputValue(hotelInput, '');
            setInputValue(destinationInput, '');
            setInputValue(roomSetupInput, '');
            setInputValue(eventTypeInput, '');
            setInputValue(capacityInput, '');
            capacityInput?.classList.remove('dirty');
            updateHotelOptions(false);

            spacesListControl.querySelectorAll('.space-card')?.forEach((spaceCard) => {
                spaceCard.classList.remove('hidden-card');
            });

            syncEmptyState(spacesListControl);
        };

        const updateUrlFromFilters = () => {
            const url = new URL(window.location.href);
            const filters = {
                destination: destinationInput?.value.trim() ?? '',
                hotels: hotelInput?.value.trim() ?? '',
                eventtype: eventTypeInput?.value.trim() ?? '',
                capacity: capacityInput?.value.trim() ?? '',
                'room-setup': roomSetupInput?.value.trim() ?? ''
            };

            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            });

            window.history.replaceState({}, '', url);
        };

        // Setup a callback to set the dirty state of the capacity field in input and change and then run it manually from the initial state
        const updateState = () => syncCapacityDirtyState(capacityInput);
        capacityInput?.addEventListener('input', updateState);
        capacityInput?.addEventListener('change', updateState);
        updateState();

        destinationInput?.addEventListener('change', () => {
            updateHotelOptions();
        });

        updateHotelOptions();


        // Get the query string parameters from the current URL and apply them to the spaces list
        const currentQueryString = window.location.search;
        if (currentQueryString || window.location.hash) {
            applyFiltersFromQueryString(currentQueryString);
        }

        spacesListControlDoc.querySelectorAll('.spaces-list-layout-dropdown').forEach((dropdown) => {
            const spacesListControl = dropdown.closest('.control-spaces-list');
            const toggle = dropdown.querySelector('.spaces-list-layout-toggle');
            const hiddenInput = dropdown.querySelector('input[type="hidden"]');
            const options = dropdown.querySelectorAll('.spaces-list-layout-option');
            const optionsList = dropdown.querySelector('.spaces-list-layout-options');
            const defaultLabel = getDefaultState()?.layoutText || (toggle?.textContent?.trim() ?? '');

            if (!toggle || !hiddenInput || options.length === 0) return;

            // Keep the custom control as one tab stop, like a native select.
            options.forEach((option) => {
                option.tabIndex = -1;
            });

            if (optionsList && !optionsList.id) {
                optionsList.id = `spaces-list-layout-options-${Math.random().toString(36).slice(2)}`;
            }
            options.forEach((option, index) => {
                if (!option.id) option.id = `${optionsList?.id || 'spaces-list-layout-option'}-${index}`;
            });
            if (optionsList) toggle.setAttribute('aria-controls', optionsList.id);

            const getSelectedOption = () => Array.from(options).find((option) => option.classList.contains('is-selected')) || options[0];

            const setSelectedOption = (option) => {
                if (!option) return;

                options.forEach((item) => {
                    const isSelected = item === option;
                    item.classList.toggle('is-selected', isSelected);
                    item.setAttribute('aria-selected', String(isSelected));
                });

                hiddenInput.value = option.dataset.value || '';
                setToggleContent(hiddenInput.value ? option : null);
                toggle.setAttribute('aria-activedescendant', option.id || '');
            };

            const setToggleContent = (option) => {
                if (!option) {
                    toggle.innerHTML = `<span class="spaces-list-layout-toggle-content"><span class="spaces-list-layout-toggle-text">${defaultLabel}</span></span>`;
                    return;
                }

                const icon = option.querySelector('.spaces-list-layout-option-icon');
                const iconMarkup = icon ? `<span class="spaces-list-layout-toggle-icon">${icon.innerHTML}</span>` : '';
                const titleText = option.querySelector('.spaces-list-layout-option-title')?.textContent?.trim() ?? defaultLabel;

                toggle.innerHTML = `<span class="spaces-list-layout-toggle-content">${iconMarkup}<span class="spaces-list-layout-toggle-text">${titleText}</span></span>`;
            };

            const closeDropdown = () => {
                dropdown.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
                optionsList?.setAttribute('aria-hidden', 'true');
            };

            const openDropdown = () => {
                spacesListControlDoc.querySelectorAll('.spaces-list-layout-dropdown.is-open').forEach((openDropdown) => {
                    if (openDropdown !== dropdown) {
                        openDropdown.classList.remove('is-open');
                        openDropdown.querySelector('.spaces-list-layout-toggle')?.setAttribute('aria-expanded', 'false');
                    }
                });

                dropdown.classList.add('is-open');
                toggle.setAttribute('aria-expanded', 'true');
                optionsList?.setAttribute('aria-hidden', 'false');
            };

            toggle.addEventListener('click', (event) => {
                event.preventDefault();

                if (dropdown.classList.contains('is-open')) {
                    closeDropdown();
                } else {
                    openDropdown();
                }
            });

            toggle.addEventListener('keydown', (event) => {
                const currentIndex = Array.from(options).indexOf(getSelectedOption());

                if (event.key === 'Tab') {
                    // A native select closes when focus moves away from it.
                    if (dropdown.classList.contains('is-open')) {
                        event.preventDefault();
                    }
                    closeDropdown();
                    return;
                }

                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
                    return;
                }

                if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

                event.preventDefault();
                const direction = event.key === 'ArrowDown' ? 1 : -1;
                const nextIndex = Math.max(0, Math.min(options.length - 1, currentIndex + direction));
                setSelectedOption(options[nextIndex]);
            });

            options.forEach((option) => {
                option.addEventListener('click', () => {
                    setSelectedOption(option);
                    closeDropdown();
                });
            });

            const filterContainer = dropdown.closest('.filter-row');
            filterContainer?.querySelector('.spaces-list-clear-search')?.addEventListener('click', (event) => {
                event.preventDefault();
                const allOption = Array.from(options).find((option) => (option.dataset.value || '') === '');
                setSelectedOption(allOption);
                resetFilters(spacesListControl);

                // Close the filter row if it's open after clearing the filters
                filterContainer.classList.remove('active');
            });

            const selectedOption = Array.from(options).find((option) => (option.dataset.value || '') === hiddenInput.value);
            setSelectedOption(selectedOption || null);
            closeDropdown();
        });

        const roomSetupDropdown = spacesListControlDoc?.querySelector('.spaces-list-layout-dropdown');

        if (roomSetupDropdown) {
            const options = roomSetupDropdown?.querySelectorAll('.spaces-list-layout-option');
            const allOption = Array.from(options).find((option) => (option.dataset.value || '') === '');
            if (allOption) {
                options.forEach((item) => item.classList.remove('is-selected'));
                allOption.classList.add('is-selected');
            }
        } else {
            spacesListControlDoc.querySelector('.spaces-list-clear-search')?.addEventListener('click', (event) => {
                event.preventDefault();
                resetFilters(spacesListControlDoc);
            });
        }

        spacesListControlDoc.querySelector('.spaces-list-filter-submit button')?.addEventListener('click', () => {
            applyFilters(spacesListControlDoc);
            updateUrlFromFilters();
        });

        capacityInput?.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                applyFilters(spacesListControlDoc);
            }
        });

        syncEmptyState(spacesListControlDoc);

        applyFilters(spacesListControlDoc);

        window.addEventListener('pageshow', () => {
            syncCapacityDirtyState(capacityInput);
        });
    });
});
